import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { GAUtils } from '../model/GAUtils';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleFooterLinkClick = (linkName: string, linkUrl: string) => {
    GAUtils.trackFooterClick(linkName, linkUrl);
  };

  const handleExternalLinkClick = (linkUrl: string, linkText: string) => {
    GAUtils.trackExternalLinkClick(linkUrl, linkText);
  };

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    GAUtils.trackLanguageChange(e.target.value);
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.footerSection}>
          <h3>Support</h3>
          <ul>
            <li>
              <a 
                href="mailto:support@xtea.app"
                onClick={() => handleExternalLinkClick('mailto:support@xtea.app', 'Contact Us')}
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.footerSection}>
          <h3>Legal</h3>
          <ul>
            <li>
              <Link 
                to="/privacy"
                onClick={() => handleFooterLinkClick('Privacy Policy', '/privacy')}
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link 
                to="/terms"
                onClick={() => handleFooterLinkClick('Terms of Service', '/terms')}
              >
                Terms of Service
              </Link>
            </li>
            <li>
              <Link 
                to="/copyright"
                onClick={() => handleFooterLinkClick('Copyright Policy', '/copyright')}
              >
                Copyright Policy
              </Link>
            </li>
          </ul>
        </div>

        <div className={styles.footerSection}>
          <h3>Company</h3>
          <ul>
            <li>
              <Link 
                to="/about"
                onClick={() => handleFooterLinkClick('About Us', '/about')}
              >
                About Us
              </Link>
            </li>
          </ul>
        </div>

      </div>

      <div className={styles.footerBadges}>
        <a href="https://dang.ai" target="_blank" rel="dofollow noopener noreferrer">
          <img src="https://img.shields.io/badge/Featured%20on-Dang.ai-orange?style=flat-square" alt="Featured on Dang.ai" style={{ height: '24px', width: 'auto' }} />
        </a>
        <a href="https://twelve.tools" target="_blank" rel="noopener noreferrer">
          <img src="https://img.shields.io/badge/Featured%20on-Twelve%20Tools-blue?style=flat-square" alt="Featured on Twelve Tools" style={{ height: '24px', width: 'auto' }} />
        </a>
        <a href="https://newtool.site" target="_blank" rel="noopener noreferrer">
          <img src="https://img.shields.io/badge/Featured%20on-NewTool.site-brightgreen?style=flat-square" alt="Featured on NewTool" style={{ height: '24px', width: 'auto' }} />
        </a>
        <a href="https://findly.tools" target="_blank" rel="noopener noreferrer">
          <img src="https://findly.tools/badges/findly-tools-badge-light.svg" alt="Featured on findly.tools" style={{ height: '24px', width: 'auto' }} />
        </a>
        <a href="https://www.uneed.best" target="_blank" rel="noopener noreferrer">Uneed</a>
        <a href="https://turbo0.com" target="_blank" rel="noopener noreferrer">Turbo0</a>
        <a href="https://fazier.com" target="_blank" rel="noopener noreferrer">Fazier</a>
      </div>

      <div className={styles.footerBottom}>
        <p>© {currentYear} XTEA.app. All rights reserved.</p>
        <div className={styles.footerLocale}>
          <select aria-label="Select language" onChange={handleLanguageChange}>
            <option value="en">English</option>
          </select>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
